import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 930px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 100px;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	ul {
		list-style: disc;
		padding-left: 10px;
	}

	ol {
		list-style: decimal;
		padding-left: 10px;
	}

	.text-section,
	.table-wrapper {
		h3 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		.p {
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}
	}

	.summary-box {
		background: linear-gradient(180deg, rgba(76, 79, 255, 0.06), rgba(76, 79, 255, 0.02));
		border: 1px solid rgba(76, 79, 255, 0.25);
		border-left: 4px solid ${CSSVars.blue500};
		border-radius: 12px;
		padding: 28px 24px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			padding: 36px 40px;
		}

		h2 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 12px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		.summary-text {
			font-size: ${CSSVars.fontSizeMD};
			line-height: 1.6;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}

			p + p {
				margin-top: 12px;
			}
		}
	}

	.alt-list-section {
		> h2 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 12px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		> .p {
			font-size: ${CSSVars.fontSizeMD};
			line-height: 1.6;
			margin-bottom: 32px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		.alt-cards {
			display: flex;
			flex-direction: column;
			gap: 24px;
		}

		.alt-card {
			position: relative;
			background: ${CSSVars.white};
			border: 1px solid ${CSSVars.gray300};
			border-radius: 14px;
			padding: 24px;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
			transition: box-shadow 0.2s ease, transform 0.2s ease;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				padding: 32px;
			}

			&:hover {
				box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
				transform: translateY(-2px);
			}

			&.featured {
				border: 2px solid ${CSSVars.blue500};
				background: linear-gradient(180deg, rgba(76, 79, 255, 0.05), ${CSSVars.white});
				box-shadow: 0 8px 28px rgba(76, 79, 255, 0.14);
			}

			.alt-card-head {
				display: flex;
				align-items: center;
				gap: 14px;
				flex-wrap: wrap;
				margin-bottom: 14px;

				.alt-rank {
					flex: none;
					width: 40px;
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 50%;
					background: ${CSSVars.gray50};
					color: ${CSSVars.blue500};
					font-weight: 700;
					font-size: ${CSSVars.fontSizeLG};
				}

				h3 {
					font-size: ${CSSVars.fontSizeLG};
					font-weight: 700;
					margin: 0;

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: ${CSSVars.fontSizeXL};
					}

					a {
						color: ${CSSVars.black};
						text-decoration: none;

						&:hover {
							color: ${CSSVars.blue500};
						}
					}
				}

				.alt-pick {
					margin-left: auto;
					background: ${CSSVars.blue500};
					color: ${CSSVars.white};
					font-size: ${CSSVars.fontSizeXS};
					font-weight: 600;
					letter-spacing: 0.04em;
					text-transform: uppercase;
					padding: 5px 12px;
					border-radius: 999px;
				}
			}

			&.featured .alt-rank {
				background: ${CSSVars.blue500};
				color: ${CSSVars.white};
			}

			.alt-best-for {
				font-size: ${CSSVars.fontSizeSM};
				color: #555;
				margin-bottom: 12px;

				span {
					font-weight: 700;
					color: ${CSSVars.black};
				}
			}

			.alt-desc {
				font-size: ${CSSVars.fontSizeMD};
				line-height: 1.65;
				color: ${CSSVars.black};
			}

			.alt-standout {
				font-size: ${CSSVars.fontSizeSM};
				margin-top: 12px;
				color: ${CSSVars.black};

				span {
					font-weight: 700;
					color: ${CSSVars.blue500};
				}
			}

			.alt-proscons {
				display: flex;
				flex-wrap: wrap;
				gap: 12px 32px;
				margin-top: 16px;

				ul {
					list-style: none;
					padding: 0;
					margin: 0;
					flex: 1 1 200px;

					li {
						position: relative;
						padding-left: 24px;
						font-size: ${CSSVars.fontSizeSM};
						line-height: 1.5;
						margin-bottom: 6px;
					}
				}

				.alt-pros li::before {
					content: '✓';
					position: absolute;
					left: 0;
					color: ${CSSVars.blue500};
					font-weight: 700;
				}

				.alt-cons li::before {
					content: '✕';
					position: absolute;
					left: 0;
					color: ${CSSVars.gray300};
					font-weight: 700;
				}
			}

			.alt-cta {
				display: inline-block;
				margin-top: 20px;
				background: ${CSSVars.blue500};
				color: ${CSSVars.white};
				font-weight: 600;
				font-size: ${CSSVars.fontSizeMD};
				padding: 12px 28px;
				border-radius: 8px;
				text-decoration: none;
				transition: background 0.2s ease;

				&:hover {
					background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
				}
			}
		}
	}

	.matrix-section {
		> h2 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 12px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		> .p {
			font-size: ${CSSVars.fontSizeMD};
			line-height: 1.6;
			margin-bottom: 24px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		.matrix-scroll {
			overflow-x: auto;
			border-radius: 12px;
			border: 1px solid ${CSSVars.gray300};
		}

		.matrix-table {
			width: 100%;
			border-collapse: collapse;
			min-width: 640px;
			margin: 0;

			th,
			td {
				padding: 14px 16px;
				text-align: center;
				border-bottom: 1px solid ${CSSVars.gray300};
				font-size: ${CSSVars.fontSizeSM};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeMD};
				}
			}

			thead th {
				background: ${CSSVars.gray50};
				font-weight: 700;
				font-size: ${CSSVars.fontSizeMD};
			}

			tbody th[scope='row'] {
				text-align: left;
				font-weight: 600;
				color: ${CSSVars.black};
				white-space: nowrap;
			}

			tbody tr:last-child th,
			tbody tr:last-child td {
				border-bottom: none;
			}

			.highlight-col {
				background: rgba(76, 79, 255, 0.06);
			}

			thead th.highlight-col {
				background: ${CSSVars.blue500};
				color: ${CSSVars.white};
			}

			tbody tr.highlight-row {
				background: rgba(76, 79, 255, 0.06);

				th[scope='row'] {
					color: ${CSSVars.blue500};
					font-weight: 700;
				}
			}
		}
	}

	.cta-block {
		text-align: center;
		background: linear-gradient(90deg, rgba(9, 10, 59, 1), rgba(1, 1, 1, 1));
		border-radius: 16px;
		padding: 44px 24px;
		color: ${CSSVars.white};

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			padding: 56px 40px;
		}

		h2 {
			color: ${CSSVars.white};
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 12px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		.cta-text {
			font-size: ${CSSVars.fontSizeMD};
			line-height: 1.6;
			max-width: 620px;
			margin: 0 auto 24px;
			opacity: 0.9;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		.cta-btn {
			display: inline-block;
			background: ${CSSVars.white};
			color: ${CSSVars.blue500};
			font-weight: 700;
			font-size: ${CSSVars.fontSizeMD};
			padding: 14px 36px;
			border-radius: 8px;
			text-decoration: none;
			transition: background 0.2s ease, color 0.2s ease;

			&:hover {
				background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
				color: ${CSSVars.white};
			}
		}

		&.light {
			background: linear-gradient(180deg, ${CSSVars.blue50} 0%, ${CSSVars.blue100} 100%);
			border: 1px solid ${CSSVars.blue100};
			color: ${CSSVars.black};

			h2 {
				color: ${CSSVars.black};
			}

			.cta-text {
				color: ${CSSVars.gray700};
				opacity: 1;
			}

			.cta-btn {
				background: ${CSSVars.blue500};
				color: ${CSSVars.white};
			}
		}
	}

	.card-helper-wrapper {
		height: fit-content;
		width: fit-content;
		position: relative;
		width: 100%;

		.throwing-stars {
			display: none;
		}
		.sword {
			display: none;
		}

		/* legacy ninja decorations removed for a cleaner look */
		.throwing-stars,
		.sword {
			display: none !important;
		}

		&.highlight .banner {
			background: linear-gradient(180deg, rgba(76, 79, 255, 0.07), rgba(76, 79, 255, 0.02));
			border: 1px solid rgba(76, 79, 255, 0.25);
			border-left: 4px solid ${CSSVars.blue500};

			h3 {
				color: ${CSSVars.blue500};
			}

			ul,
			ol {
				list-style: none;
				padding: 0;
			}

			&.align-left ul li,
			ul li {
				position: relative;
				padding-left: 28px;
				text-align: left;
				margin-bottom: 10px;
				line-height: 1.5;

				&::before {
					content: '✓';
					position: absolute;
					left: 0;
					top: 0;
					color: ${CSSVars.blue500};
					font-weight: 700;
				}
			}
		}

		.banner {
			padding: 40px;
			background: ${CSSVars.white};
			border: 1px solid ${CSSVars.gray300};
			border-radius: 14px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
			text-align: center;
			z-index: 20;
			position: relative;
			font-size: ${CSSVars.fontSizeMD};

			a {
				background-color: transparent;
				border: none;
				color: black;

				&:hover {
					color: ${CSSVars.blue};
				}
			}

			ul,
			ol {
				margin: 0 auto;
				width: fit-content;
			}

			.banner-text {
				margin-top: 10px;
				text-align: center;
			}

			.trustpilot-container {
				max-width: 350px;

				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 20px;
				flex-wrap: wrap;
				margin: 30px auto 0;

				img {
					max-width: 100%;
					height: 100%;
				}

				p {
					font-size: ${CSSVars.fontSizeMD};
				}
			}

			&.align-left {
				text-align: left;

				.trustpilot-container {
					margin: 30px 0 0;
				}

				ul,
				ol {
					margin: unset;
					width: fit-content;
				}
				.banner-text {
					text-align: left;
				}
			}

			h3 {
				font-size: ${CSSVars.fontSizeLG};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				padding: 50px;
				font-size: ${CSSVars.fontSizeLG};
			}
		}
	}

	table {
		color: ${CSSVars.black};
		margin: 30px auto 0;
		border-collapse: collapse;
		table-layout: fixed;

		max-width: 100%;
		width: 100%;

		@media screen and (max-width: ${CSSVars.breakpointSM}) {
			width: 100%;
			display: block;
			overflow-x: auto;
		}

		thead {
			position: sticky;
			top: 0;
			background-color: ${CSSVars.white};
			box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05);

			&.has-inner-nav {
				top: 65px;
			}

			th {
				&:nth-child(1) {
					border-left: none;
					&:not(.first-td) {
						text-align: left;
						vertical-align: bottom;
						width: 25%;

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							width: 35%;
						}
					}
				}

				&:last-child {
					border-right: none;
				}
			}

			tr {
				&:last-of-type {
					border-bottom: 1px solid ${CSSVars.gray300};
				}
			}
		}

		tr {
			overflow: scroll;

			&:last-of-type {
				border-bottom: 2px solid white;
			}

			ul,
			ol {
				list-style: none;
			}

			&.align-left {
				td {
					vertical-align: baseline;

					&:not(:first-child),
					&.first-td {
						text-align: left;
					}
				}
			}
		}

		td {
			padding: 20px;
			border: 1px solid ${CSSVars.gray300};
			vertical-align: middle;

			&:nth-child(1) {
				border-left: none;
				&:not(.first-td) {
					font-size: ${CSSVars.fontSizeSM};
				}
			}
			&:last-child {
				border-right: none;
			}

			&:not(:first-child),
			&.first-td {
				text-align: center;
				font-size: ${CSSVars.fontSizeMD};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
				}
			}

			.note {
			}

			.checked {
				font-size: 34px;
				color: ${CSSVars.blue};
			}

			.x {
				width: 18px;
				color: ${CSSVars.gray300};
			}
		}

		th {
			border: 1px solid ${CSSVars.gray300};
			border-top: none;
			border-bottom: none;
			padding: 20px;

			font-size: ${CSSVars.fontSizeLG};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}

			p {
				margin: 10px 10px 20px;
				color: ${CSSVars.blue};
				font-size: ${CSSVars.fontSizeMD};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}

				span {
					font-size: ${CSSVars.fontSizeXS};

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: ${CSSVars.fontSizeSM};
					}
				}
			}

			button {
				margin: 0 auto;
				padding: 6px 10px;
				font-size: 12px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: 14px;
					padding: 8px 20px;
				}
			}
		}
	}
`;
